import Input from 'components/common/form/input/Input';
import { Form, Formik } from 'formik';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import * as Yup from 'yup';
import { Props } from './passwordResetForm.type';
import { useResetPasswordMutation } from 'service/authQuery/authQuery';
import { FormValues } from '../profilePasswordReset.type';
import { useToast } from 'hooks/useToast';

const validationSchema = Yup.object().shape({
  currentPassword: Yup.string().required('Current password is required'),

  password: Yup.string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/,
      'Password must contain at least one letter and one number'
    ),

  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password')], 'Passwords must match')
});

function PasswordResetForm({ innerRef }: Props) {
  const [resetPassword] = useResetPasswordMutation();
  const { open } = useToast();
  const handleSubmit = (value: FormValues) => {
    resetPassword(value)
      .unwrap()
      .then(res => {
        open(res?.data, 'success');
        innerRef.current?.resetForm();
      })
      .catch(err => open(err?.data?.error, 'error'));
  };

  return (
    <div className="mb-5">
      <Formik
        innerRef={innerRef}
        initialValues={{
          currentPassword: '',
          password: '',
          confirmPassword: ''
        }}
        validationSchema={validationSchema}
        onSubmit={value => {
          handleSubmit(value);
        }}
      >
        <Form>
          <Row className="g-5">
            <Col xs={12} xl={8}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="currentPassword">
                  Your Current Password
                </FormLabel>
                <Input
                  name="currentPassword"
                  id="currentPassword"
                  type="password"
                />
              </FormGroup>
            </Col>
            <Col xs={12} xl={8}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="password">New Password</FormLabel>
                <Input name="password" id="password" type="password" />
              </FormGroup>
            </Col>
            <Col xs={12} xl={8}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="confirmPassword">
                  Confirm New Password
                </FormLabel>
                <Input
                  name="confirmPassword"
                  id="confirmPassword"
                  type="password"
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </Formik>
    </div>
  );
}

export default PasswordResetForm;
